module.exports = __webpack_public_path__ + "img/open-link.7e605ddd.svg";